<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {laboratoryApi} from "@/container";
import {Skeleton} from "@/core/components/ui/skeleton";
import AttachmentCard from "@/attachment/components/AttachmentCard.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {useRouter} from "vue-router";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import useLaboratory from "@/laboratory/composables/useLaboratory";

const props = defineProps<{ laboratoryId: string }>();

const router = useRouter();
const {data: laboratory} = useLaboratory(props.laboratoryId);
const {data, isLoading} = useSwr(
    computed(() => cacheKey(`laboratories/${props.laboratoryId}/attachments`)),
    () => laboratoryApi().attachments(Number(props.laboratoryId), {limit: 3}),
    {
        revalidateOnFocus: false
    }
);

/**
 * Go to the attachments page.
 */
const displayAttachments = () => {
    router.push({name: 'laboratory.attachments', params: {laboratoryId: props.laboratoryId}});
};
</script>

<template>
  <div v-if="isLoading">
    <Skeleton class="w-full h-48 rounded-md" />
  </div>
  <div v-else-if="data?.data?.length" class="bg-white rounded-md p-4">
    <div class="flex flex-row items-center gap-4">
      <h2 class="text-black">Ressources</h2>
      <BaseButton variant="text" @click="displayAttachments">
        Voir toutes les ressources
      </BaseButton>
    </div>
    <div class="flex flex-row items-center justify-center py-4">
      <div v-for="attachment in data.data" :key="attachment.id" class="grid grid-cols-3 gap-4">
        <attachment-card
          :attachment="attachment"
          tint-color="#00000030"
          text-color="#000"
          :icon-color="laboratory?.branding?.primary_color"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>